import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import styles from "./index.module.scss";
import { Modal, Input, Checkbox, message, Tooltip } from "antd";
import { CheckItemType, EditFormType } from "..";
import SafeVerify, { FaCheckProps } from "@/components/App/SafeVerify";
import { axiosThrottle, omitObj } from "@/utils/method";
import { waitRes } from "@/utils/axios";
import { get_getFaCheckItem, post_userAccountApiKeyUpdate } from "@/api/uaapi/user";
import store from "store";
interface ApiModalProps extends BaseCompProps {
  attr?: any;
  visible: boolean;
  title?: string;
  form: EditFormType;
  closeApiModal?(bool: boolean): void;
  onFormChange?(changedValues: Partial<EditFormType>): void;
}

let faResultId = "";
const { useTranslation } = Hooks;

const ApiModal: React.FC<ApiModalProps> = ({ className, visible, title = "", form, closeApiModal, onFormChange }) => {
  const t = useTranslation();
  const [faCheckData, setFaCheckData] = useState<FaCheckProps>({
    faCheckId: "",
    faItems: [],
  });
  const { notSub } = store.user;

  useEffect(() => {
    getFaCheckItem();
  }, []);

  const getFaCheckItem = async () => {
    const { data, err } = await waitRes(get_getFaCheckItem, {
      noHandle401: true,
      errorPop: true,
      params: { faBizType: 58 },
    });
    if (err) return;

    faResultId = data.faCheckId;
    setFaCheckData(data);
  };
  /**method */
  const submitForm = axiosThrottle(async (unlock, { faResultId }) => {
    const { data, err } = await waitRes(post_userAccountApiKeyUpdate, {
      data: {
        id: form.id,
        keyName: form.keyName,
        faResultId,
        bindIps: form.bindIps,
        roleScopes: form.roleScopes.join(","),
      },
      errorPop: true,
    });
    unlock();
    await getFaCheckItem();
    if (err) return closeApiModal?.(false);
    message.success(t("account.success"));
    closeApiModal?.(true);
  });
  return (
    <Modal
      className={cx(styles["common_modal"], styles["api_modal"])}
      open={visible}
      title={title}
      width={500}
      footer={null}
      onCancel={() => closeApiModal?.(false)}
    >
      <div className={styles["modal_content"]}>
        <div className={styles["api_form_group"]}>
          <div className={styles["form_group"]}>
            <div className={styles["form_container"]}>
              <Input
                className={styles["api_form_input"]}
                placeholder={t("account.AliasName")}
                value={form.keyName}
                onChange={(e) => onFormChange?.({ keyName: e.target.value })}
              />
              <Input
                className={styles["api_form_input"]}
                placeholder={t("account.WhitelistIP")}
                value={form.bindIps}
                autoComplete="new-text"
                onChange={(e) => onFormChange?.({ bindIps: e.target.value })}
              />
              <Checkbox.Group
                value={form.roleScopes}
                className={styles["api_checkbox"]}
                onChange={(checkedValue) => onFormChange?.({ roleScopes: checkedValue as CheckItemType[] })}
              >
                <Checkbox value={"QUERY"} className={styles["checkbox_list"]} disabled>
                  {t("account.QueryAuthority")}
                </Checkbox>
                <Checkbox value={"TRADE"} className={styles["checkbox_list"]}>
                  {t("account.TradingAuthority")}
                </Checkbox>
                {notSub && (
                  <Tooltip placement="top" title={t("account.WithdrawalAuthorityTip")}>
                    <Checkbox value={"WITHDRAW"} className={styles["checkbox_list"]}>
                      {t("account.WithdrawalAuthority")}
                    </Checkbox>
                  </Tooltip>
                )}
                <Tooltip placement="top" title={t("account.LeverLoanAuthorityTip")}>
                  <Checkbox value={"LEVER_LOAN"} className={styles["checkbox_list"]}>
                    {t("account.LeverLoanAuthority")}
                  </Checkbox>
                </Tooltip>
                <Tooltip placement="top" title={t("account.FutureAuthorityTip")}>
                  <Checkbox value={"FUTURE"} className={styles["checkbox_list"]}>
                    {t("account.FutureAuthority")}
                  </Checkbox>
                </Tooltip>
                <Tooltip placement="top" title={t("account.TransferAuthorityTip")}>
                  <Checkbox value={"TRANSFER"} className={styles["checkbox_list"]}>
                    {t("account.TransferAuthority")}
                  </Checkbox>
                </Tooltip>
              </Checkbox.Group>

              <SafeVerify faCheckData={faCheckData} showLink={false} faBizType={58} dynamicCodeType={"USER_2025"} handleSuccessFn={submitForm} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default observer(ApiModal);
